import React from "react";
import "../Components/Home.css";
import { FaTools, FaUsers, FaClipboardList, FaHome } from "react-icons/fa";
import homepage1 from "../Images/Hometitle.png";
import Home2 from "./home2";
import HomeSlider from "./HomeSlider";


function Home() {
  return (
<>
     
    <div className="App">
      {/* Hero Section */}
      {/* Hero Section */}
<section className="hero-section">
  <div className="hero-text">
    <h1 className="hero-title">
      Design Your Dream Stay – <br />Crafted by You, for You…
    </h1>
  </div>

  <div className="hero-image-wrapper">
    <img src={homepage1} alt="Modern House" className="hero-absolute-image" />
  </div>
</section>


      {/* Why Choose Us */}
     <section className="why-choose">
      <h2>Why Choose Us!</h2>
      <div className="choose-icons">
        <div className="icon-box">
          <div className="icon-circle">
            <FaTools className="icon" />
          </div>
          <h3 style={{ textAlign: "center" , fontWeight: "bold" }}>Quality Engineering</h3>

          <p className="description">
            We deliver precision and reliability through innovative engineering practices.
          </p>
        </div>

        <div className="icon-box">
          <div className="icon-circle">
            <FaUsers className="icon" />
          </div>
          <h3 style={{ textAlign: "center" , fontWeight: "bold"}}>Expert Team</h3>
          <p className="description">
            Our professionals bring years of experience and technical mastery to every project.
          </p>
        </div>

        <div className="icon-box">
          <div className="icon-circle">
            <FaClipboardList className="icon" />
          </div>
          <h3 style={{ textAlign: "center" , fontWeight: "bold" }}>Trusted Service</h3>
          <p className="description">
            We prioritize integrity, transparency, and customer trust in all we do.
          </p>
        </div>

        <div className="icon-box">
          <div className="icon-circle">
            <FaHome className="icon" />
          </div>
          <h3 style={{ textAlign: "center" , fontWeight: "bold" }}>Customer Satisfaction</h3>
          <p className="description">
            Our goal is to exceed expectations and create lasting partnerships with every client.
          </p>
        </div>
      </div>
    </section>
    <Home2 />
    <HomeSlider/>
  


    
    </div>
    </>
  );
  
}


export default Home;
